import type { OpportunitySet, OpportunityTabCounts } from "../types/opportunities.types"

/** Tab badge counts — completed_scripts reflects server metadata only, not in-flight bulk progress. */
export function computeOpportunityTabCounts(selectedSet: OpportunitySet | null): OpportunityTabCounts {
  return {
    active: selectedSet?.activeCount ?? 0,
    completed_scripts: selectedSet?.completedScriptsCount ?? 0,
    rejected: selectedSet?.rejectedCount ?? 0,
  }
}
